module.exports = __webpack_public_path__ + "static/media/icon-ln-blue.da8efd46.svg";